module.exports = __webpack_public_path__ + "static/media/FR-70.bb3fff0d.geojson";